import type { FC } from "react";
import { DIMENSION_COLOR } from "./deckSlopeViewConstants";
import DimensionTick from "./DimensionTick";

type HorizontalDimensionProps = {
  xLeft: number;
  xRight: number;
  y: number;
  dimY: number;
  label: string;
  strokeWidth: number;
  tickSizePx: number;
  fontSize: number;
};

// The horizontal counterpart of VerticalDimension, with its label centered below the dimension line.
const HorizontalDimension: FC<HorizontalDimensionProps> = ({
  xLeft,
  xRight,
  y,
  dimY,
  label,
  strokeWidth,
  tickSizePx,
  fontSize,
}) => {
  const overshoot = tickSizePx * 0.6;

  return (
    <g>
      <line x1={xLeft} y1={y} x2={xLeft} y2={dimY + overshoot} stroke={DIMENSION_COLOR} strokeWidth={strokeWidth} />
      <line x1={xRight} y1={y} x2={xRight} y2={dimY + overshoot} stroke={DIMENSION_COLOR} strokeWidth={strokeWidth} />
      <line x1={xLeft} y1={dimY} x2={xRight} y2={dimY} stroke={DIMENSION_COLOR} strokeWidth={strokeWidth} />
      <DimensionTick
        point={{ x: xLeft, y: dimY }}
        sizePx={tickSizePx}
        strokeWidth={strokeWidth}
        color={DIMENSION_COLOR}
      />
      <DimensionTick
        point={{ x: xRight, y: dimY }}
        sizePx={tickSizePx}
        strokeWidth={strokeWidth}
        color={DIMENSION_COLOR}
      />
      <text
        x={(xLeft + xRight) / 2}
        y={dimY + fontSize * 1.3}
        textAnchor="middle"
        fontSize={fontSize}
        fill={DIMENSION_COLOR}
        fontWeight={600}
      >
        {label}
      </text>
    </g>
  );
};

export default HorizontalDimension;
